import axios from "axios";

// TODO: use this as a wrapper to handle ajax that fails due to expired sessions

export default axios;
